/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { globalBreak } from '@/styles/break';
import { SxProps, Theme } from '@mui/material';

export const productDetailsAddToWishListMenuItemSX: SxProps<Theme> = {
	'&.MuiMenuItem-root': {
		px: 1,
		'&:not(:last-child)': {
			borderBottom: (theme) => `1px solid ${theme.palette.grey[300]}`,
		},
	},
};

export const productDetailsWishListIconSX: SxProps<Theme> = {	
	fontSize: '32px',
	//color:'black'
};

export const productDetailsItemAddedToWishListIconSX: SxProps<Theme> = {	
	fontSize: '32px',
	color:'black',
	fill: '#ffdc00',
};

export const productDetailsWishListButtonSX: SxProps<Theme> = {	
	fontSize: 'large',
	'&:hover':{
		backgroundColor: 'transparent'
	},
	px:globalBreak({mobile:0, desktop:'20px'}),
	py:0
};

export const pdpWishListContainerButtonSX:SxProps = {
	height:50,
	width:50,
	bgcolor:'#ebebeb',
	borderRadius:'50%',
}

export const productDetailsAddToWishListMenuSX:SxProps<Theme> = (theme) => ({
	zIndex: theme.zIndex.PdpDeliverySection + 1
})